
<ion-content [hidden]="searchResultsEnable">

 <ion-refresher (ionRefresh)="doRefresh($event)">
    <ion-refresher-content
      pullingIcon="arrow-dropdown"
      pullingText=""
      refreshingSpinner="crescent"
      refreshingText="">
    </ion-refresher-content>
  </ion-refresher> 
 

  <!-- <div>
      <scroll-tabs #scrollTab [tabs]="tabs" (onSelectedTab)="tabChange($event)"></scroll-tabs>
    </div> -->


  
  <ion-list *ngIf="visible">
      <ion-card *ngFor="let deal of dealslist; let i = index;">

          <!-- <img src="img/advance-card-map-madison.png"> -->
          <img [src]="deal.DealListImage"  (click)="clickevent(deal)" />
          <img  [src]="getFlagImage(deal)" style="height:18px" />

      <!--     <img *ngIf="deal.RecommendedFlag" src="assets/savingsimg/img_recommended_deal_flag.png" style="height:18px" />
          <img *ngIf="deal.FeaturedFlag" src="assets/savingsimg/img_featured_deal_flag.png" style="height:18px" />
          <img *ngIf="deal.DealOfWeekFlag" src="assets/savingsimg/img_hot_deal_flag.jpg" style="height:18px" />
 -->
        <ion-item>
        <h2 text-wrap><b>{{deal.DealTitle}}</b></h2>  
        <div  class="box"  text-wrap>
            <span style="">{{deal.PartnerName}}</span>
            <button style="vertical-align:middle;padding:0px" ion-button clear (click)="favourite(deal.DealID,deal.FavoritePartnerFlag,deal, i)">
                <img [src]="deal.FavoritePartnerFlag ? 'assets/savingsimg/ic_acgdeal_favorite_active.png' : 'assets/savingsimg/ic_acgdeal_favorite.png'" style="width:36px;height:36px;padding:6px">
                </button>
          </div>
        </ion-item>

     <ion-item>
    <span item-start *ngIf="deal.OnlineFlag && !deal.PhoneFlag">
        <div  class="box"  text-wrap>
            <img  src="assets/savingsimg/ic_detail_online_small.png" style="vertical-align:middle;width:36px;height:36px;padding:6px" />
            <span style="font-size:1.2rem">Online offer</span>
          </div>
    </span>
    <span item-start *ngIf="deal.PhoneFlag && !deal.OnlineFlag">
        <div  class="box"  text-wrap>
            <img  src="assets/savingsimg/ic_detail_telephone_small.png" style="width:36px;height:36px;padding:6px" />
            <span style="font-size:1.2rem">Phone offer</span>
          </div>
        
      </span>
      <span item-start *ngIf="deal.PhoneFlag && deal.OnlineFlag">
        <div  class="box"  text-wrap>
            <img  src="assets/savingsimg/ic_detail_online_phone_small.png" style="width:36px;height:36px;padding:6px" />
            <span style="font-size:1.2rem">Online & Phone offer</span>
          </div>
        
      </span>
      <span item-start  *ngIf="deal.StoreFrontFlag">
          <div  class="box" text-wrap>
              <img  src="assets/savingsimg/ic_detail_location.png" style="width:36px;height:36px;padding:6px" />
<!--               <span style="font-size:1.2rem">{{deal.distance}}</span>
 -->              <span style="font-size:1.2rem">{{getDistance(deal)}}</span>
            </div>
          
        </span>
        <span item-start *ngIf="isExpired(deal)">
          <div  class="box" text-wrap>
              <img  [src]="deal.expiringdays >5 ? 'assets/savingsimg/ic_detail_expires_small_disable.png' : 'assets/savingsimg/ic_detail_expires_small.png'" style="width:36px;height:36px;padding:6px" />
             <span style="font-size:1.2rem">{{expireddays(deal)}}</span>
            </div>
          
        </span>
    <span item-end  *ngIf="deal.AAADollarsFlag">
        <img  src="assets/savingsimg/aaa_dollars.png" style="width:56px;height:40px;padding:6px" />

    </span>
    <span item-end  *ngIf="deal.HotDealFlag">
        <img  src="assets/savingsimg/img_hot.png" style="width:36px;height:36px;padding:6px" />

    </span>
    
  </ion-item>
          <!-- <ion-item>
            <span item-start>18 min</span>
            <span item-start>(2.6 mi)</span>
            <button ion-button icon-start clear item-end>
              <ion-icon name="navigate"></ion-icon>
              Start
            </button>
          </ion-item> -->
        
        </ion-card>

        <ion-item *ngIf="nodeals">
          No Deals Available
        </ion-item>
       
  </ion-list>
  <ion-infinite-scroll *ngIf="patination" (ionInfinite)="doInfinite($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
<ion-content  *ngIf="searchResultsEnable">
  <search-results-page [params]="searchparams"></search-results-page>
  
  </ion-content>
<ion-content  *ngIf="!isNetworkConnected">
    <ion-row class="no_network_message">
        <ion-col text-center>
            The Discounts & Rewards search engine is currently unavailable.<br>
            Please try again in a short while
        </ion-col>
    </ion-row>
    
</ion-content>   